import React from "react";
import Skeleton from "react-loading-skeleton";
import { Pencil } from "lucide-react";

export default function ExIpaDataTable({
  tableData = [],
  dataLoading = false,
  onEdit = () => {},
}) {
  return (
    <div className="docpro_table_responsive docpro_exipa_table_wrap">
      <table className="docpro_mb_0">
        <thead>
          <tr>
            <th>ID</th>
            <th>IPA Name</th>
            <th>Associated Users</th>
            <th className="docpro_text_center">Action</th>
          </tr>
        </thead>

        <tbody>
          {!dataLoading ? (
            tableData && tableData.length > 0 ? (
              tableData.map((item) => (
                <tr key={item.id}>
                  <td className="py-2">{item.id}</td>

                  <td className="py-2">
                    {item?.ipa_name || "-"}
                  </td>

                  <td className="py-2">
                    <div className="docpro_exipa_users_cell">
                      {item.assotiate_users?.length > 0 ? (
                        <div className="docpro_exipa_users_scroll custom-scroll">
                          {item.assotiate_users.map((u) => (
                            <div className="docpro_exipa_user_row" key={u.user_id}>
                              {u.user_first_name} {u.user_last_name}{" "}
                              {u.user_email ? <span>({u.user_email})</span> : null}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>-</span>
                      )}
                    </div>
                  </td>

                  <td className="docpro_text_center">
                    <div className="docpro_icon_btns">
                      <button
                        type="button"
                        className="docpro_icon_btn last_btn_tip"
                        onClick={() => onEdit(item)}
                      >
                        <Pencil width={18} height={18} />
                        <span className="docpro_tip">Edit</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "450px" }} colSpan="10">
                  No data available
                </td>
              </tr>
            )
          ) : (
            Array.from({ length: 8 }).map((_, index) => (
              <tr key={index} style={{ height: "50px" }}>
                <td>
                  <Skeleton width="2.5rem" borderRadius="8px" />
                </td>
                <td>
                  <Skeleton width={`${6 + (index % 2)}rem`} borderRadius="8px" />
                </td>
                <td>
                  <Skeleton width={`${10 + (index % 3)}rem`} borderRadius="8px" />
                </td>
                <td className="docpro_text_center">
                  <Skeleton width="2.5rem" borderRadius="8px" />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
